export enum SidebarItemType {
  Dashboard = 'dashboard',
  Listings = 'listings',
  Profiles = 'profiles',
  ListingRequests = 'listingRequests',
  Reports = 'reports',
  LeadManagement = 'leadManagement',
  PhotoService = 'photoService',
  CompanyManagement = 'companyManagement',
  UserManagement = 'userManagement',
  ReleaseNotes = 'releaseNotes',
  HomesIQ = 'homesIQ'
}
